import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

function detectInitial() {
  const stored = localStorage.getItem("vc_lang");
  if (stored === "es" || stored === "en") return stored;
  const nav = (navigator.language || navigator.userLanguage || "es").toLowerCase();
  return nav.startsWith("es") ? "es" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("vc_lang", l);
    setLangState(l);
  };
  const toggle = () => setLang(lang === "es" ? "en" : "es");

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
}
